import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import { UserProfileProvider } from './contexts/userProfile';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import store from './components/store';
import AppRoutes from './routes/index.tsx';
import { AuthProvider } from './contexts/authContext.tsx';

import './global.css'

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <UserProfileProvider>
        <CookiesProvider>
          <AuthProvider>
            <Provider store={store}>
              <AppRoutes />
            </Provider>
          </AuthProvider>
        </CookiesProvider>
      </UserProfileProvider>

      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}

    </QueryClientProvider>
  );
}

export default App;
